<template>
    <el-form ref="formRef" :disabled="saving" :rules="rules" :model="car" label-position="top">
        <el-form-item prop="name" label="Identificador do carro">
            <el-input name="name" v-model="car.name" />
        </el-form-item>
        <el-form-item prop="reference" label="Referência">
            <el-input name="reference" v-model="car.reference" />
        </el-form-item>
        <el-form-item prop="plate" label="Placa">
            <el-input name="plate" v-model="car.plate" />
        </el-form-item>
        <el-form-item prop="places" label="Quantidade de cadeira">
            <el-input-number :step="1" :min="1" name="price" v-model="car.places" />
        </el-form-item>

        <el-button plain  :loading="saving" size="large" type="primary" @click.prevent="submit(formRef)">
            Cadastrar carro
        </el-button>
    </el-form>
</template>

<script lang="ts" setup>
    import Api from "@/services/api"
    import { Car } from "@/services/types"
    import { ElMessage, FormInstance, FormRules } from "element-plus"
    import { reactive, ref, defineProps, defineEmits } from "vue"

    const props = defineProps<{travel_company_id: number}>()
    const emit = defineEmits<{close: []}>()

    const car = reactive<Car>({
        name: '',
        plate: '',
        reference: '',
        travel_company_id: props.travel_company_id,
        places: 0
    })

    const rules = reactive<FormRules<Car>>({
        name: [{required: true, message: 'Preencha os campos', min: 1}],
        plate: [{required: true, message: 'Preencha os campos', min: 1}],
        reference: [{required: true, message: 'Preencha os campos', min: 1}],
    })

    // const image = ref()
    // const uri = ref<string>()
    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true

                const res = await Api.post(`admin/cars/${props.travel_company_id}`, car)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Carro cadastrado com sucesso'})
                    emit('close')
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }
</script>
